import React from "react";

export function Button(props: ButtonProps) {
    const { color = "primary", icon, label, disabled, colorReversed, onClick, height, width } = props;

    const handleButtonClicked = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        onClick();
    };

    const style = {
        height: height ? `${height}px` : "",
        width: width ? `${width}px` : "240px"
    };

    const reversedClassName = colorReversed ? "button--reversed" : "";

    return (
        <div className={"button"}>
            <button style={style} className={`button__button ${reversedClassName} ${color}`} disabled={disabled} type="button" onClick={handleButtonClicked}>
                {icon}
                {label}
            </button>
        </div>
    );
}

export type ButtonProps = {
    color?: "primary" | "delete",
    icon?: JSX.Element,
    label: string,
    onClick: () => void,
    disabled?: boolean,
    colorReversed?: boolean,
    height?: number,
    width?: number
};
